import { useRef } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { Download, Printer } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "../ui/dialog";

export const batchUrl = (batch) => `${window.location.origin}/reports?batch=${encodeURIComponent(batch)}`;

const esc = (s) => String(s ?? "").replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));

export const BatchQrDialog = ({ report, productName, onClose }) => {
  const wrap = useRef(null);
  const open = Boolean(report);
  const dataUrl = () => wrap.current?.querySelector("canvas")?.toDataURL("image/png");

  const download = () => {
    const a = document.createElement("a");
    a.href = dataUrl();
    a.download = `KGF-batch-${report.batch_no}-QR.png`;
    a.click();
  };

  const print = () => {
    const w = window.open("", "_blank", "width=480,height=640");
    if (!w) return;
    w.document.write(`<html><head><title>Batch ${esc(report.batch_no)}</title><style>
      body{font-family:Arial,sans-serif;margin:0;display:flex;justify-content:center}
      .l{width:70mm;padding:6mm;text-align:center;border:1px dashed #999;margin:8mm}
      img{width:52mm;height:52mm}h1{font-size:15px;margin:2mm 0 1mm;letter-spacing:.08em}p{font-size:11px;margin:1mm 0;color:#333}
    </style></head><body><div class="l">
      <h1>KASHYAP GREEN FUELS</h1><img src="${dataUrl()}" alt="QR"/>
      <p><b>Batch ${esc(report.batch_no)}</b></p><p>${esc(productName)} · Tested ${esc(report.test_date)}</p><p>Scan to see the lab test report</p>
    </div><script>window.onload=()=>{window.print();}</script></body></html>`);
    w.document.close();
  };

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent data-testid="batch-qr-modal" className="max-w-sm rounded-[28px] border hairline bg-[var(--forest-2)] text-[var(--cream)]">
        {report && (
          <>
            <DialogHeader>
              <DialogTitle className="font-display text-2xl">Batch {report.batch_no}</DialogTitle>
              <DialogDescription className="text-[var(--sage)]">{productName} · tested {report.test_date}. Scanning opens this batch's test report.</DialogDescription>
            </DialogHeader>
            <div ref={wrap} className="mx-auto rounded-2xl bg-white p-4">
              <QRCodeCanvas data-testid="batch-qr-code" value={batchUrl(report.batch_no)} size={512} level="M" marginSize={1} style={{ width: 220, height: 220 }} />
            </div>
            <p data-testid="batch-qr-url" className="font-mono text-[11px] text-[var(--sage)] break-all text-center">{batchUrl(report.batch_no)}</p>
            <div className="grid grid-cols-2 gap-3">
              <button data-testid="batch-qr-download" onClick={download} className="h-11 rounded-full border hairline inline-flex items-center justify-center gap-2 hover:bg-white/5"><Download className="h-4 w-4" />PNG</button>
              <button data-testid="batch-qr-print" onClick={print} className="h-11 rounded-full bg-[var(--husk)] text-[var(--forest)] font-semibold inline-flex items-center justify-center gap-2"><Printer className="h-4 w-4" />Print label</button>
            </div>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};
